import InlineButton from "../ui/inline-button";
import PrimaryButton from "../ui/primary-button";
import SecondaryButton from "../ui/secondary-button";
import { cn } from "@/lib/utils";

export interface CIAppDemoRequestFormSuccessProps {
  className?: string;
  onSubmitAnotherRequest: () => void;
  aboutUsHref?: string;
  faqsHref?: string;
}

export default function CIAppDemoRequestFormSuccess({
  className,
  onSubmitAnotherRequest,
  aboutUsHref = "#about-us",
  faqsHref = "#faqs",
}: CIAppDemoRequestFormSuccessProps) {
  return (
    <div className={cn("flex h-fit flex-col gap-6", className)}>
      <div className="flex flex-col gap-2">
        <h3 className="font-montserrat text-heading-4 text-secondary-500 md:text-heading-2">
          You&apos;re One Step Closer to Smarter Staffing!
        </h3>
        <p className="font-montserrat text-subheading-3-500 text-neutral-600 md:text-subheading-2">
          Thank you for requesting a demo. We appreciate your interest in the
          Care Indeed App.
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <p className="font-montserrat text-body-1-300 text-neutral-500">
          Our team will contact you within 24 hours to schedule your
          personalized demonstration. We&apos;re excited to show you how Care
          Indeed can transform your facility&apos;s staffing operations.
        </p>
        <p className="font-montserrat text-body-1-300 text-neutral-500">
          While you wait, why not prepare by thinking about your biggest
          staffing challenges? We&apos;ll address them directly during your
          demo.
        </p>
      </div>
      <div className="flex flex-row gap-4">
        <PrimaryButton
          color="teal"
          href={aboutUsHref}
        >
          About Us
        </PrimaryButton>
        <SecondaryButton
          color="gray"
          href={faqsHref}
        >
          FAQs
        </SecondaryButton>
      </div>
      <InlineButton
        color="gray"
        onClick={onSubmitAnotherRequest}
      >
        Submit another request
      </InlineButton>
    </div>
  );
}
